module.exports = __webpack_public_path__ + "img/am-black-friday-2021.fa510e1f.jpg";